import { BOSS_MODE_LABEL } from 'data/global';
import {
  DEAL_ROOM_SEARCH,
  DealRoomSearch,
  SearchResultItem,
  SHARED_SECTION,
} from 'models/Search';
import { DealRoom, DEAL_ROOM_VIEW_SOURCE } from 'models/DealRoom';
import utils, { getPortfolioRoute } from 'utils';

export const ALL_DEALS = 'all';

export const getSearchSectionTitle = (
  type: DealRoomSearch | string,
  isSuperAdmin?: boolean,
) =>
  isSuperAdmin && type === SHARED_SECTION.MARKETPLACE ? BOSS_MODE_LABEL : type;

const isSelectedFilter = (key: string, filter: string) =>
  key === filter || filter === ALL_DEALS;

export const isValidDealSection = (
  key: string,
  value: number,
  filter: string,
  isLoggedIn: boolean,
  isSuperAdmin: boolean,
) => {
  if (key === SHARED_SECTION.BEST_MATCH) return false;

  const isMarketplace = key === SHARED_SECTION.MARKETPLACE;
  const isBuying = key === DEAL_ROOM_SEARCH.BUYING;
  const isDrafts = key === DEAL_ROOM_SEARCH.DRAFTS;

  if (!isLoggedIn) {
    return isMarketplace; // If not logged in, only allow MARKETPLACE
  }

  if (!value && isDrafts) return false; // if Drafts is empty hide drafts tab and section

  if (isSelectedFilter(key, filter)) {
    if (isSuperAdmin) {
      return !isBuying; // If logged in and super admin disallow BUYING
    }

    return true; // If logged in and not super admin allow all
  }

  return false; // Key does not pass any condition
};

export const getRecentlyViewedDealRoute = (deal: DealRoom) => {
  const { _id, listingEnquiryId, listing, source, industry } = deal;

  if (source === DEAL_ROOM_VIEW_SOURCE.BUSINESS)
    return utils.composeBusinessUrl(industry, listing?.slugName, listing?.type);

  return getPortfolioRoute(
    source === DEAL_ROOM_VIEW_SOURCE.BUYING,
    _id,
    listingEnquiryId,
  );
};

export const groupBySection = (deals: SearchResultItem[]) =>
  deals.reduce<Record<string, SearchResultItem[]>>((acc, deal) => {
    if (!deal.section) return acc;

    acc[deal.section] = [...(acc[deal.section] ?? []), deal];

    return acc;
  }, {});

export const mergeWithBestMatch = (
  value: SearchResultItem[],
  bestMatchForSection: SearchResultItem[] = [],
) => {
  if (!bestMatchForSection.length) return value;

  const existingIds = new Set(value.map(({ _id }) => _id));
  const additions = bestMatchForSection.filter(
    ({ _id }) => !existingIds.has(_id),
  );

  return [...value, ...additions];
};
